var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { environmentOm } from '../../environment-om';
import { Http2Factory } from './http2-factory';
export class Api {
    constructor(http2Factory) {
        this.http2Factory = http2Factory;
        this.layerProperties = `
        name,
        id,
        categoryId,
        filter,
        description,
        isGroupLayer,
        labelingInfoJSON,
        sources,
        url,
        symbolsJSON,
        parentId
    `;
        this.http2 = http2Factory.create(environmentOm.mapcoreApi);
        this.report = http2Factory.create(environmentOm.oneMapApi);
    }
    getLayers(id, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const props = query || this.layerProperties;
            return yield this.http2.graphqlRequest(`
                query GetLayers($id: [Int]) {
                    layers(id: $id){
                        ${props}
                    }
                }
        `, { id }, 'GET', 'layers');
        });
    }
}
